var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroupStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    id: "User-Group--Streamline-Flex",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    User Group Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-group--user-group-meeting-leader"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.114724142857144 8.407457464285715c0.8901655714285716 0.15990276428571432 1.7173105714285717 0.5009896714285715 2.4421665000000004 0.9837296357142858 0.9141563571428573 0.6088765928571429 0.6097956428571429 1.6676938071428573 -0.24814350000000004 2.0749284428571433",
    strokeWidth: 1.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.71483195714286 1.7981511642857144c0.07938443571428573 -0.005192035714285715 0.16083375000000003 -0.00779402142857143 0.2442763285714286 -0.00779402142857143 1.5033032142857146 0 2.348829214285715 0.8455737428571429 2.348829214285715 2.348817278571429 0 0.8868593785714286 -0.29433471428571434 1.544815628571429 -0.8443324285714288 1.935280585714286",
    strokeWidth: 1.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.844977 12.124179214285716c1.4332405714285716 0.9546184285714286 0.4654928571428572 2.7957023571428574 -1.2565800642857143 2.7957023571428574H5.121603064285715c-1.7220490500000003 0 -2.689856442857143 -1.8410839285714289 -1.256603935714286 -2.7957023571428574C5.150594914285715 11.267958814285716 6.694527300000001 10.768950471428573 8.355 10.768950471428573c1.660484635714286 0 3.2044050857142863 0.4990083428571429 4.4899770000000006 1.355228742857143Z",
    strokeWidth: 1.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.35708875 8.87438260714286c1.8752558785714286 0 2.930074628571429 -1.0548306857142857 2.930074628571429 -2.930074628571429s-1.0548187500000001 -2.930074628571429 -2.930074628571429 -2.930074628571429c-1.8752439428571432 0 -2.930062692857143 1.0548306857142857 -2.930062692857143 2.930074628571429s1.0548187500000001 2.930074628571429 2.930062692857143 2.930074628571429Z",
    strokeWidth: 1.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_3",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.5955742500000003 8.407457464285715c-0.8901297642857144 0.15990276428571432 -1.71737025 0.5009896714285715 -2.4421820164285717 0.9837296357142858 -0.9141909707142858 0.6088765928571429 -0.6097837071428571 1.6676938071428573 0.2481828878571429 2.0749284428571433",
    strokeWidth: 1.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.9954545 1.7981511642857144C4.916070064285715 1.7929591285714288 4.834632685714286 1.7903571428571432 4.7511543000000005 1.7903571428571432c-1.503243535714286 0 -2.348817278571429 0.8455737428571429 -2.348817278571429 2.348817278571429 0 0.8868593785714286 0.2943108428571429 1.544815628571429 0.8443563000000002 1.935280585714286",
    strokeWidth: 1.29
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroupStreamlineFlex);
export default __webpack_public_path__ + "static/media/User-Group--Streamline-Flex.8d274807438db2b3161dd44262b682bb.svg";
export { ForwardRef as ReactComponent };